import { FC, PropsWithChildren, useContext, useMemo } from 'react'

import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { Context as AuthContext, Me } from './Auth'

const queryClient = new QueryClient()

const cache = new InMemoryCache({
  typePolicies: {
    Translations: {
      keyFields: ['documentId'],
    },
    Rider: {
      keyFields: ['documentId'],
    },
    Article: {
      keyFields: ['documentId'],
    },
    Track: {
      keyFields: ['documentId'],
    },
    Result: {
      keyFields: ['documentId'],
    },
    Race: {
      keyFields: ['documentId'],
    },
  },
})

const Data: FC<PropsWithChildren<{ apiUrl?: string }>> = ({ apiUrl = '', children }) => {
  const { token } = useContext(AuthContext)
  const client = useMemo(
    () =>
      new ApolloClient({
        uri: `${apiUrl}/graphql`,
        cache,
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      }),
    [apiUrl, token],
  )

  return (
    <ApolloProvider client={client}>
      <Me>
        <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
      </Me>
    </ApolloProvider>
  )
}
export { Data }
